import * as yup from 'yup';

export const committeeMembersSchema = yup.object({
    individualId: yup.number().nullable().required('Member is required'),
    dateAppointed: yup.date().nullable().required('Date Appointed is required'),
    isActive: yup.boolean().nullable().required('Status is required'),
    dateResigned: yup.date().when('isActive', {
        is: (isActive: boolean) => isActive === false,
        then: yup.date().typeError("Date Resigned is required").required("Date Resigned is required"),
        otherwise: yup.date().nullable()
    })
})